import { render, staticRenderFns } from "./BaseSelectSingle.vue?vue&type=template&id=f051a8ea&"
import script from "./BaseSelectSingle.vue?vue&type=script&lang=ts&"
export * from "./BaseSelectSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
